import React from 'react'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { PasswordInput, PasswordInputProps } from '../../PasswordInput'

interface PasswordInputControllerProps<T extends FieldValues> extends PasswordInputProps {
  control: Control<T, any>
  name: FieldPath<T>
  shouldUnregister?: boolean
  defaultValue?: any
  meta?: any
}

export const PasswordInputController = <T extends FieldValues>({
  name,
  control,
  shouldUnregister,
  defaultValue,
  ...rest
}: PasswordInputControllerProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field }, fieldState, formState }) => {
        const meta = {
          error: fieldState.error,
        }

        return <PasswordInput {...field} fieldRef={ref} {...rest} meta={meta} />
      }}
    />
  )
}
